//localStorage 
export const LOCAL_STORAGE_TEMP_CONFIG = 'config:';
export const LOCAL_STORAGE_ACCESS_TOKEN = 'sd_cp.jwt:tkn';